/**
 * origamiPaper — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const origamiPaperPack: ToilePack = {
    slug: 'origami-paper',
    category: 'origami',
    name: 'Origami paper',
    tagline: tagline('sheets', 'patterns', 'styles'),
    chips: chips('patterns', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'sakura', label: 'Sakura', subject: 'sakura blossoms and drifting petals on slender branches'},
        {key: 'seigaiha', label: 'Seigaiha waves', subject: 'concentric arcs overlapping in even rows'},
        {key: 'stars', label: 'Scattered stars', subject: 'small stars of varied size with sparkle dots'},
    ],
    styles: [
        {key: 'washi', label: 'Traditional washi', style: 'hand-screened chiyogami with gold leaf', palette: 'deep indigo, vermilion and cream', framing: 'square sheet, edge to edge'},
        {key: 'geometric', label: 'Modern geometric', style: 'flat straight-edged shapes, crisp and graphic', palette: 'limited three-color palette', framing: 'square sheet, edge to edge'},
        {key: 'gradient', label: 'Soft gradient', style: 'the motif ghosted over a shifting wash', palette: 'pale, low-contrast color', framing: 'square sheet, edge to edge'},
    ],
    directions: ['cranes instead', 'in black and gold', 'a smaller, denser repeat'],
}
